var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "url(#pattern0_597_922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_597_922",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_597_922",
    transform: "matrix(0.0384615 0 0 0.0360577 0 -0.00480769)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_597_922",
    width: 26,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAAAXNSR0IArs4c6QAAA8pJREFUSEutlk1oXUUUx/9n0qTSrCStVUuphWr8qFIKfhQFbRdWIiH0zdwbNX40LooK2iDVRauS1rYLN6KCGFwoSC3MzL0mRhQLNYW6tJZiWpWCiJTiIqEQRPpIcv9mnhNJ40vus2ZWl8v/zO98zDkzggZXlmXrANxNchXJSyTPpmn6Q4PmkDJhnufbSB4kuaWO9jyAA1rrIyLCxfZaEERS8jwPgL1lzoiIa2lp2dnZ2fnnQtoFQc6510XkQDS8TPIDpdRnSqnfpqenV5J8WEReBtAWNAFWqVS6F4qsLshau0kp9X2wB3ChKIrtaZqem+9tnufXFUXxOYB7I+xprfUn9aKqC3LO5SKyA8C0iNyjtQ7Qustau6qpqekcyZUAzhtjbmkINDw8vKJarY4DuAaANcZ0l9XIObdXRA4FnVJqU6VSOTPf5l8R5Xm+sSiK2rEVkV6t9cdloCzLNpM8FXVPGGOOloKccw+JyEgQzhh3JknyRQOgdSR/jbo+Y8w7pSDv/V0AaqGTfC5JkoEGQPeT/DZmoUdr/WkpaGBgoLmtre0SgFYAx4wx28tA3vu3ALwSdEVR3Jqm6c+loCDw3oe6PBPFjxpjvlzk1LXHVlgB4LQxZnNDpy6IrLUblFKjAJYDmCD5WJIkX83fwFp7p1JqCMD6MqcWnAxZlu0k+dGczb8GkJG8ICJtIvJIcABAU9S8bYwJk6LuWnSoeu+fB/B+WY0ADGmtdyw2WOuCRkZGlo2NjfUB2CMiqxsABUloiVeNMd81VCNr7XqlVGi42vyKRzbcP9+QPCMiYyKynORaEdlC8r44E4N0GsCh0dHR/f39/cVc4BURxeKGoq+Jol9IvtHa2uo7Ojqq9TwdHBxcOzU1tQfACwCWRc3RoiieStM0gP92dvbDWnu9iJwSkRtjFAMTExN9vb29lxtJXWz0DMCGqH/XGLP7ClC45LIsOw5ga4T0a633NwKYqwmTXCkVanVH+E8yTZLE/ROR9/5xALWxISJHtNZP/lfIrD6+LU6TvJbkRZLtaZr+UUud9z5carcBGK9Wqzf39PSEEXTVK8uyXSRrM1JEXtJavyfW2geUUidjqPuSJDl81YRoGNpjfHw8PFxuAnDWGLNRvPcHAewLmubm5jVdXV0X/y8o2Dvn3hSR12b3FefccRHZBuBHY8ztSwEJe1hrH1RKnYjpS0JEPwFoJ+mTJEmWCjQ0NLR6cnLy99k6BVBI1Q0zTfqhMWbXUoGstS1KqdCDEpo+9M+LJLuLotidpunsvb8kPOfcYRHZOvMWfPYv2PiX2d7b4nMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.48faa13e736a69fa73046831701082e1.svg";
export { ForwardRef as ReactComponent };